import React, { useState } from 'react';
import { FadeIn, CountdownTimer, Button } from './Shared';
export const PricingSection = () => {
  const [plan, setPlan] = useState<'standard' | 'premium'>('premium');
  const plans = {
    standard: {
      id: 'standard',
      icon: '📘',
      title: 'MÉTODO CAJA ORDENADA',
      subtitle: '5 Tomos + 4 Bonos',
      ideal: 'Ordenar pedidos, cobros, señas, stock, entregas y caja semanal. Dejar de perder plata por desorden operativo desde esta semana.',
      oldPrice: '$69.000',
      price: '$19.990',
      url: 'https://mundopractico.online/cart/48731797422297:1',
      buttonText: 'MI MÉTODO CAJA ORDENADA'
    },
    premium: {
      id: 'premium',
      icon: '🏆',
      title: 'MÉTODO CAJA ORDENADA + KIT VENTA RELÁMPAGO',
      subtitle: '5 Tomos + 4 Bonos + Campañas express para convertir stock parado en caja',
      ideal: 'Resolver el desorden de hoy Y aprender a mover el stock dormido, reactivar clientas viejas y generar caja rápida con campañas de 48 horas. El sistema completo: defensa y ataque.',
      oldPrice: '$89.000',
      price: '$27.990',
      url: 'https://mundopractico.online/cart/48731815968985:1',
      buttonText: 'EL MÉTODO + KIT VENTA RELÁMPAGO',
      isPopular: true
    }
  };
  const currentPlan = (plans as any)[plan];
  const trackCheckout = (planName: string, price: string) => {
    if (typeof window !== 'undefined' && (window as any).fbq) {
      const numericPrice = parseFloat(price.replace('$', '').replace('.', ''));
      (window as any).fbq('track', 'InitiateCheckout', {
        content_name: planName,
        value: numericPrice,
        currency: 'ARS'
      });
    }
  };
  return <section id="pricing" className="py-16 md:py-24 px-4 bg-navy-950 relative overflow-hidden" data-id="element-242">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_50%,rgba(236,72,153,0.03),transparent_70%)] pointer-events-none" data-id="element-243"></div>
      <div className="max-w-3xl mx-auto relative z-10" data-id="element-244">
        <FadeIn data-id="element-245">
          <div className="text-center mb-12" data-id="element-246">
            <h2 className="text-[10px] md:text-xs font-black tracking-[0.2em] text-pink-500 uppercase mb-8 bg-pink-500/10 inline-block px-4 py-2 rounded-full border border-pink-500/20" data-id="element-247">
              ⏰ PRECIO DE LANZAMIENTO
            </h2>
            <CountdownTimer data-id="element-248" />

            <div className="max-w-sm mx-auto mt-10 bg-navy-900/40 border border-white/5 rounded-2xl p-5 backdrop-blur-sm" data-id="element-249">
              <div className="flex justify-between items-center text-[10px] md:text-xs font-black mb-3 uppercase tracking-widest" data-id="element-250">
                <span className="text-gray-400 flex items-center gap-2" data-id="element-251">
                  <span className="w-2 h-2 rounded-full bg-pink-500 animate-pulse shadow-[0_0_10px_rgba(236,72,153,0.5)]" data-id="element-252"></span>
                  Cupos disponibles
                </span>
                <span className="text-pink-400" data-id="element-253">68% Reclamado</span>
              </div>
              <div className="h-1.5 bg-navy-950 rounded-full overflow-hidden border border-white/5 p-0.5" data-id="element-254">
                <div className="h-full bg-gradient-to-r from-pink-500 to-fuchsia-500 w-[68%] rounded-full relative" data-id="element-255">
                  <div className="absolute inset-0 bg-white/20 animate-pulse" data-id="element-256"></div>
                </div>
              </div>
            </div>

            <p className="mt-8 font-sans font-medium text-sm md:text-base text-gray-400" data-id="element-257">
              ⚠️ Después de esta oferta el precio sube $8.000 ARS.
            </p>
            <h3 className="text-3xl md:text-5xl font-black text-white mt-8 mb-10 uppercase tracking-tight leading-none font-[Montserrat,_sans-serif]" data-id="element-258">
              ELEGÍ TU{' '}
              <span className="text-pink-400" data-id="element-259">MÉTODO CAJA ORDENADA</span>
            </h3>
          </div>

          <div id="planes-container" className="space-y-5 mb-10" data-id="element-260">
            {(Object.values(plans) as any[]).map(p => {
            const isSelected = plan === p.id;
            return <button key={p.id} id={`plan-${p.id}`} onClick={() => setPlan(p.id)} className={`w-full text-left transition-all duration-300 rounded-[2rem] p-5 md:p-8 border-2 flex flex-col md:flex-row items-start md:items-center gap-5 md:gap-8 relative overflow-hidden scroll-mt-24 md:scroll-mt-32 ${isSelected ? 'bg-navy-900/80 border-pink-500 shadow-[0_10px_40px_rgba(236,72,153,0.1)] transform scale-[1.01] z-10' : 'bg-navy-900/30 border-white/5 hover:border-white/10 hover:bg-navy-900/50'}`} data-id="element-261">
                  {isSelected && <div className="absolute top-0 left-0 w-1.5 h-full bg-gradient-to-b from-pink-400 via-pink-500 to-fuchsia-500" data-id="element-262" />}

                  <div className="flex items-center w-full md:w-auto gap-4" data-id="element-263">
                    {/* Radio Indicator */}
                    <div className={`w-6 h-6 md:w-8 md:h-8 rounded-full border-2 shrink-0 flex items-center justify-center transition-all duration-300 ${isSelected ? 'border-pink-500 bg-pink-500/10' : 'border-white/20 bg-navy-950'}`} data-id="element-264">
                      {isSelected && <div className="w-3 h-3 md:w-4 md:h-4 rounded-full bg-pink-400 shadow-[0_0_10px_rgba(236,72,153,0.8)]" data-id="element-265" />}
                    </div>

                    <span className="text-2xl md:text-4xl shrink-0 filter drop-shadow-md md:hidden" data-id="element-266">
                      {p.icon}
                    </span>

                    {p.isPopular && <span className="md:hidden ml-auto text-[9px] bg-pink-500/20 text-pink-400 border border-pink-500/30 font-bold px-3 py-1 rounded-full uppercase tracking-widest font-sans" data-id="element-267">
                        ⭐ MÁS ELEGIDO
                      </span>}
                  </div>

                  {/* Content */}
                  <div className="flex-grow min-w-0 w-full" data-id="element-268">
                    <div className="flex items-center flex-wrap gap-3 mb-2.5" data-id="element-269">
                      <span className="text-3xl md:text-4xl shrink-0 filter drop-shadow-md hidden md:block" data-id="element-270">
                        {p.icon}
                      </span>
                      <h4 className={`text-lg md:text-2xl font-black uppercase tracking-tight break-words leading-tight ${isSelected ? 'text-pink-400' : 'text-white'}`} data-id="element-271">
                        {p.title}
                      </h4>
                      {p.isPopular && <span className="hidden md:inline-block text-[10px] bg-pink-500/20 text-pink-400 border border-pink-500/30 font-bold px-3 py-1 rounded-full uppercase tracking-widest font-sans ml-2" data-id="element-272">
                          ⭐ MÁS ELEGIDO
                        </span>}
                    </div>
                    <p className={`text-xs md:text-sm mb-4 font-sans font-bold break-words uppercase tracking-wide ${isSelected ? 'text-white/90' : 'text-gray-300'}`} data-id="element-273">
                      {p.subtitle}
                    </p>
                    <div className={`p-3.5 md:p-4 rounded-xl ${isSelected ? 'bg-navy-950/50 border border-white/5' : 'bg-navy-950/30'}`} data-id="element-274">
                      <span className={`block text-[9px] md:text-[10px] uppercase tracking-widest font-bold mb-1.5 ${isSelected ? 'text-pink-400' : 'text-gray-400'}`} data-id="element-275">
                        Ideal para:
                      </span>
                      <p className={`text-xs md:text-sm font-medium tracking-wide leading-relaxed break-words font-sans ${isSelected ? 'text-gray-200' : 'text-gray-400'}`} data-id="element-276">
                        {p.ideal}
                      </p>
                    </div>
                  </div>

                  {/* Price */}
                  <div className="text-left md:text-right shrink-0 md:ml-auto mt-4 md:mt-0 w-full md:w-auto border-t border-white/5 md:border-t-0 pt-4 md:pt-0 flex flex-row md:flex-col items-end justify-between md:justify-center" data-id="element-277">
                    <p className={`line-through text-xs md:text-sm mb-1 font-bold opacity-60 ${isSelected ? 'text-gray-300' : 'text-gray-400'}`} data-id="element-278">
                      {p.oldPrice}
                    </p>
                    <p className={`text-3xl md:text-4xl font-black transition-colors tracking-tighter ${isSelected ? 'text-white' : 'text-gray-200'}`} data-id="element-279">
                      {p.price}{' '}
                      <span className={`text-xs md:text-sm font-black block md:inline opacity-60 ${isSelected ? 'text-pink-400' : 'text-gray-400'}`} data-id="element-280">
                        ARS
                      </span>
                    </p>
                  </div>
                </button>;
          })}
          </div>

          <div className="mt-10" data-id="element-281">
            <Button href={currentPlan.url} className="w-full text-base md:text-xl py-5 md:py-7" onClick={() => trackCheckout(currentPlan.title, currentPlan.price)} data-id="element-282">
              🟠 → QUIERO {currentPlan.buttonText}
            </Button>
            <div className="flex flex-col items-center mt-5 text-gray-400 text-xs gap-2 font-sans font-medium" data-id="element-283">
              <p className="flex items-center gap-2" data-id="element-284">
                <span className="w-1.5 h-1.5 bg-green-400 rounded-full" data-id="element-285" />
                Acceso inmediato por email • Pago 100% seguro
              </p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
};